<template>
  <div class="leo2-news">
    <div class="header">
      <span class="back" @click="goBack()"></span>
      资讯动态
    </div>
    <div class="scroller" ref="scroller">
      <van-tabs v-model="active" animated :sticky="true" @change="onChange" :swipeable="true" line-width="28" line-height="4" color="#FF5000">
        <van-tab v-for="(item, index) in tab_title" :key="index">
          <template #title>
            <span>{{ item.name }}</span>
          </template>
          <div class="content" v-for="(l,index) in list" :key="index">
            <div class="list" :class="{'list2':l.Type === '2'}">
              <a :href="'/news/detail/'+l.Id">
                <div class="imgs" :class="{'no':!l.Img}">
                  <img :src="l.Img" v-if="l.Img" />
                  <img src="/static/images/no.png" v-else />
                </div>
                <div class="con">
                  <div class="title">
                    {{l.Title}}
                  </div>
                  <div class="time">
                    {{l.Year}}-{{l.Date}}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <Ball></Ball>
  </div>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs } from "vant";
Vue.use(Tab);
Vue.use(Tabs);
import "vant/lib/tab/style";
import "vant/lib/tabs/style";
import Ball from "@/components/ball.vue";
export default {
  name: "index",
  components: {
    Ball
  },
  data() {
    return {
      list: [],
      active: 0,
      tab_title: [
        { 'name': "全部", id: 0, list: [], finished: false, page: 1 },
        { 'name': "行业新闻", id: 1, list: [], finished: false, page: 1 },
        { 'name': "游好赚动态", id: 2, list: [], finished: false, page: 1 }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    goBack() {
      window.history.length > 2 ? this.$router.go(-1) : this.$router.push('/')
    },
    goPage(id) {
      this.$router.push({
        name: 'detail',
        params: {
          id: id
        }
      })
    },
    onChange(active) {
      this.$refs.scroller.scrollTop = 0;
      this.tab_title[this.active].finished = false;
      this.loadData(1);
    },
    loadData() {
      this.axios.news({ newsType: this.active })
        .then(res => {
          if (res.data.code === 0) {
            if (res.data.data.rows.length > 0) {
              this.list = res.data.data.rows
            } else {
              this.list = []
            }
          } else {
            this.list = []
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .leo2-news {
    padding-top: 44px;
    max-width: 750px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    position: relative;
    .header {
      position: fixed;
      overflow: hidden;
      top: 0;
      left: 0;
      right: 0;
      height: 44px;
      line-height: 44px;
      background-color: #333;
      color: white;
      text-align: center;
      z-index: 999;
      font-size: 18px;

      .back {
        position: absolute;
        left: 5px;
        top: 0;
        background: url("../../assets/imagesMobile/icon-back.png") no-repeat left center;
        background-size: 24px;
        padding-left: 25px;
        width: 30px;
        height: 100%;
        cursor: pointer;
      }
    }
    .scroller{
      height: calc(100vh - 44px);
      overflow-y:scroll;
      padding-bottom: 90px;
      box-sizing: border-box;
    }
    .content {
      margin: 15px;
      overflow: hidden;
      box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px; //将颜色提到前面，且将h-shadow,v-shadow设为0px,实现四周阴影
      .list {
        padding-top: 10px;
        padding-left: 10px;
        padding-bottom: 10px;
        position: relative;
        background: url("../../assets/imagesMobile/label_news_mobile.png") no-repeat right top;
        background-size: 40px 40px;
        border-radius: 5px;
        overflow: auto;
        a{
          display: block;
        }
        .imgs {
          width: 100px;
          height: 67px;
          float: left;
          &.no{
            display: flex;
            align-items: center;
            justify-content: center;
            img{
              width: 102px;
              height: 55px;
            }
          }
          img {
            width: 100%;
            height: 100%;
          }
        }

        .con {
          position: absolute;
          float: left;
          left: 120px;
          right: 35px;
          top: 10px;
          bottom: 10px;

          .title {
            font-size: 13px;
            color: #333;
            line-height: 18px;
            height: auto;
          }

          .time {
            line-height: 12px;
            position: absolute;
            bottom: 0px;
            font-size: 12px;
            color: #999;
          }
        }
      }

      .list2 {
        background: url("../../assets/imagesMobile/label_official_mobile.png") no-repeat right top;
        background-size: 40px 40px;
      }
    }
  }

  /deep/.van-tabs{
    .van-tabs__wrap{
      line-height: 80px;
      height: 80px;
      .van-tab--active{
        .van-tab__text{
          font-weight: bold;
        }
      }
      .van-tab__text{
        font-size: 24px;
        line-height: 80px;
      }
    }
    .van-tabs__wrap{
      width: 100%;
      position: fixed;
      top: 88px;
      z-index: 10000;
    }
    .van-tabs__content{
      padding-top: 80px;
    }
  }
</style>
